import { render, staticRenderFns } from "./FeeDeposit.vue?vue&type=template&id=37c58bcc&scoped=true"
import script from "./FeeDeposit.vue?vue&type=script&lang=js"
export * from "./FeeDeposit.vue?vue&type=script&lang=js"
import style0 from "./FeeDeposit.vue?vue&type=style&index=0&id=37c58bcc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c58bcc",
  null
  
)

export default component.exports